import React, { useRef } from "react";
import { useMutation } from "@apollo/client/react";
import { faFlag, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { TextInput } from "@/components/forms";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { MUTATE_REPORT_POST } from "@/gql/queries/mutate-report-post";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";
import ReportPostFailedModal from "./report-post-failed";
import ReportPostSubmittedModal from "./report-post-submitted";

type PostReportModalProps = {
  postId: number;
};

const PostReportModal = ({ postId }: PostReportModalProps) => {
  const { openModal, closeModal } = useModal();
  const inputRef = useRef<HTMLInputElement>(null);
  const [reportPost] = useMutation(MUTATE_REPORT_POST, {
    onCompleted: () => {
      openModal(() => <ReportPostSubmittedModal />);
    },
    onError: () => {
      openModal(() => <ReportPostFailedModal />);
    },
  });

  const onCancelClicked = () => {
    closeModal();
  };

  const onReportClicked = () => {
    reportPost({
      variables: {
        id: postId,
        reason: inputRef?.current?.value ?? "",
      },
    });
    closeModal();
  };

  return (
    <div>
      <ModalTitle>Report Inappropriate Comment</ModalTitle>
      <Module>
        <p>Comments should be suitable for all ages.</p>
        <p>Some things considered inappropriate include:</p>
        <ul className="list-disc list-inside">
          <li>Swearing or offensive language</li>
          <li>Spam</li>
        </ul>
      </Module>
      <Module>
        <p>
          If you think this comment is not appropriate, you can report it here.
          You can optionally submit a reason why you think it is not
          appropriate.
        </p>
      </Module>
      <Module>
        <TextInput
          id="reportReason"
          type="text"
          name="report-reason"
          label="Report reason:"
          ref={inputRef}
        />
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="negative"
          >
            Cancel
          </Button>
          <Button icon={faFlag} onClick={onReportClicked} type="positive">
            Submit report
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default PostReportModal;
